export const mongoIdFromDate = (date) => `${Math.floor(date.getTime() / 1000)
  .toString(16)}0000000000000000`;

export const dateFromMongoId = (objectId) => new Date(
  parseInt(objectId.substring(0, 8), 16) * 1000,
);
